import cn from 'classnames';
import type { FC} from 'react';
import { memo } from 'react';

import Close from '@mui/icons-material/Close';
import { IconButton, useMediaQuery } from '@mui/material';

import { House } from '@shared/assets';

import { getPhoneNumber } from 'library/helpers/events/normalizeEventValue';
import type { ScheduleAddress } from 'library/models/schedules';

import * as st from './AddressCard.module.scss';

interface Props {
	address: ScheduleAddress;
	index: number;
	isDisabled: boolean;
	handler: (id: number) => void;
}

const validAddress = (address: ScheduleAddress): string => {
	return (
		address &&
		(address.city ? `г. ${address.city}` : '') +
			(address.street ? `, ул. ${address.street}` : '') +
			(address.house ? `, д. ${address.house}` : '') +
			(address.apartment ? `, к. ${address.apartment}` : '')
	);
};

const AddressCard: FC<Props> = ({ address, index, isDisabled, handler }) => {
	const matches = useMediaQuery('(min-width:600px)');
	return (
		<div className={st.card}>
			<div className={cn(st.icon, st.house)}>
				<House />
				<p>{index + 1}</p>
			</div>
			<div className={st.info}>
				<p className={st.address}>{`Адрес: ${validAddress(address)}`}</p>
				<p className={st.phone}>
					{`Телефон:`}
					{!matches ? <br /> : ' '}
					<span>{getPhoneNumber(address.phone)}</span>
				</p>
				<p className={st.note}>{`Комментарий для клиента: ${address.note}`}</p>
			</div>
			<div className={st.icon}>
				<IconButton
					className={st.close}
					type="button"
					disabled={isDisabled}
					onClick={() => {
						handler(address.id);
					}}
				>
					<Close />
				</IconButton>
			</div>
		</div>
	);
};

export default memo(AddressCard);
